import { CloseOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import React from 'react';

import DiffViewer from '../DiffViewer';

export interface PreviewSchemaModalProps {
  handleCancel?: () => void;
  handleConfirm?: () => void;
  newSchema?: any;
  oldSchema?: any;
  open?: boolean;
}

const PreviewSchemaModal: React.FC<PreviewSchemaModalProps> = ({ handleCancel, handleConfirm, newSchema, oldSchema, open }) => {
  return (
    <Modal
      open={!!open}
      onCancel={handleCancel}
      width="70%"
      title={'Review Your Changes'}
      footer={
        handleConfirm && (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button autoFocus type="primary" onClick={handleConfirm}>
              Save Schema
            </Button>
          </div>
        )
      }
      closeIcon={<CloseOutlined />}
    >
      <DiffViewer oldValue={JSON.stringify(oldSchema, null, 2)} newValue={JSON.stringify(newSchema, null, 2)} splitView />
    </Modal>
  );
};

export default PreviewSchemaModal;
